module.exports = __webpack_public_path__ + "static/media/image.45d38596.png";